import React, { useEffect, useState } from "react";
import Profile from "../Components/Profile";
import useAccessToken from "../Custom/useAccessToken";
import { getRandomProfiles } from "../Services/GetService";
import { Skeleton } from "primereact/skeleton";
import { Paginator } from "primereact/paginator";

const Home: React.FC = () => {
   
  const { accessToken } = useAccessToken();
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [first, setFirst] = useState(0);
  const [rows] = useState(25);

  useEffect(() => {
    if (!accessToken) return;
    getRandomProfilesFn();
  }, [accessToken]);

  const getRandomProfilesFn = async () => {
    setLoading(true);
    try {
      const res = await getRandomProfiles(accessToken);
      setResults(res || []);
    } catch (err) {
      console.error("Error occured while fetching random profile:", err);
      setResults([]);
    }
    setLoading(false);
  };

  const ProfileSkeleton = () => (
    <div className="profile-card">
      <div className="profile-left">
        <Skeleton shape="circle" size="80px" />
        <div className="profile-info">
          <Skeleton
            width="180px"
            height="1.2rem"
            className="profile-name mb-2"
          />
          <Skeleton
            width="150px"
            height="1rem"
            className="profile-title mb-2"
          />
        </div>
      </div>
      <div className="profile-right">
        <Skeleton width="160px" height="1rem" className="profile-meta mb-2" />
        <Skeleton width="130px" height="1rem" className="profile-meta mb-2" />
      </div>
    </div>
  );

  return (
    <div
      className="p-3 mt-6 surface-ground main-contain-home"
      style={{ height: "calc(100vh - 72px)"}}
    >
      <div className="mx-auto" style={{ maxWidth: "1040px"}}>

        <div className="mb-3">
          <div className="mb-2 text-3xl font-semibold">
            Discover Your Network
          </div>
          <div className="text-sm profile-description ">
            Search and connect with colleagues across LBMC. Find expertise,
            collaborate on projects, and build your professional network
            within the firm.
          </div>
        </div>

        {loading ? (
          <div className="profiles-list">
            {Array.from({ length: 4 }).map((_, i) => (
              <ProfileSkeleton key={i} />
            ))}
          </div>
        ) : (
          <div className="profiles-list-with-pagination">
            <div className="profiles-list">
              {results
                ?.slice(first, first + rows)
                .map((person: any, index: any) => (
                  <div key={index} className="cursor-pointer">
                    <Profile
                      key={index}
                      {...person}
                      isSearching={false}
                      searchQuery={null}
                    />
                  </div>
                ))}
            </div>

            {results.length > rows && (
              <Paginator
                first={first}
                rows={rows}
                totalRecords={results.length}
                onPageChange={(e) => setFirst(e.first)}
                className="custom-paginator"
                // rowsPerPageOptions={[25, 50, 100]}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
